import { render } from "./TradeCustomRangeCalendar.vue?vue&type=template&id=e22cdd52"
import script from "./TradeCustomRangeCalendar.vue?vue&type=script&lang=js"
export * from "./TradeCustomRangeCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__